import React, { Component } from 'react';
import _ , { isEmpty } from 'lodash';
import Moment from 'moment';

import 'react-infinite-calendar/styles.css'; // Make sure to import the default stylesheet
import { BarChart, LineChart, DoughnutChart, ProgressChart } from '../PaygChart'
import Payments from './Payments';
import CurrencyFormat from 'react-currency-format';
import ClientState from '../ClientPrint/ClientState';
import { Button, Grid, Box, CircularProgress, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { MiniPaper } from '../../../commonModules/layouts/CardPage';
import Currency from '../../../commonModules/Currency';
import { AssignmentTurnedInRounded, CalendarViewDayRounded, EventRounded, InfoRounded, MonetizationOnRounded, PrintRounded, VerifiedUserRounded } from '@material-ui/icons';
import { amber, blue, deepPurple, green, pink } from '@material-ui/core/colors';
import CreditScore from './CreditScore';

// Affiche la date d'enregistrement de l'association box/client, avec l'ancienneté humanisée.
// Extrait en fonction locale car utilisé à la fois dans le rendu "avec paiements" et
// dans la branche "pas assez d'info" (client sans paiement).
const RegistrationDatePaper = ({ userInfo = {} }) => (
    <MiniPaper
        title="Date d'enregistrement"
        subtitle={userInfo.timeCreation ? new Date(userInfo.timeCreation).toLocaleDateString('fr-FR') : '—'}
        avatar={<EventRounded fontSize="large" style={{ color: deepPurple[400] }}/>}
    >
        <Typography variant="h6">
            {userInfo.timeCreation ? Moment(userInfo.timeCreation).fromNow() : '—'}
        </Typography>
    </MiniPaper>
)

class Stats extends Component{
    state = {
        paymentList: [],
        loading: true,
    }
    componentDidMount = () => {
        this.getPaymentsList()
    }
    componentDidUpdate = (prevProps) => {
        // Les paiements du compte arrivent en différé (/money/ca/global/info) :
        // sans ce recalcul, une popup ouverte avant la fin du chargement restait
        // sur « Pas Assez d'info » même une fois les données en store.
        const prevIDs = prevProps.paymentsIDList || []
        const nextIDs = this.props.paymentsIDList || []
        if (prevIDs.length !== nextIDs.length || prevProps.PAYMENTS !== this.props.PAYMENTS) {
            this.getPaymentsList()
        }
    }
    getPaymentsList = () => {
        const { PAYMENTS, paymentsIDList } = this.props
        let payment_info_list = []
        paymentsIDList.map( ID => {
            if(PAYMENTS[ID] && PAYMENTS[ID].methodPayment !== 'gift'){
                payment_info_list.push(PAYMENTS[ID])
            }
        })
        this.setState({
            paymentList: payment_info_list,
            loading: false
        })
    }

    render(){
        const { userInfo, paymentsIDList, reportsIDList, REPORTS, PAYMENTS } = this.props
        const { loading, paymentList } = this.state;
        let lastPayment = null
      
        if(paymentList.length > 0){ 
            lastPayment = _.last(paymentList)
            console.log('================== _.last(paymentList) ==================');
            console.log({lastPayment});
            console.log('====================================');
        }
    
        return(
            <div>
                {/* <h4 className="text-center">
                Box {userInfo.idBox} - {userInfo.clientName}
                </h4> */}
                {loading && 
                    <Box style={{ textAlign: "center"}}>
                        <CircularProgress color="primary" />
                    </Box>
                }
                { !loading && !isEmpty(this.state.paymentList) &&
                    <Box>
                        <Box p={2} style={{display: 'flex', justifyContent:'space-between'}}>
                            {this.props.abo.type === 'Day' &&
                                <CreditScore  
                                    userInfo={userInfo} 
                                    paymentList={this.state.paymentList} 
                                    abo={this.props.abo}
                                />
                            }
                            <Button 
                                color="secondary" 
                                onClick={() => this.setState({ print: true }) }
                                startIcon={<PrintRounded />}
                            >
                                Imprimer
                            </Button>
                        </Box>
                        {this.state.print &&
                            <ClientState {...this.props} close={() => this.setState({ print: false}) } />
                        }
                        <Grid container spacing={2}>
                            {/* Les 5 cartes dans leur propre grille : la ligne des graphiques (5+7) repart sur une grille vierge. */}
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6} md={3}>
                                        <MiniPaper
                                            title="Statut Box"
                                            subtitle={userInfo.systemStatus}
                                            avatar={userInfo.systemStatus === "FullyPaid" ?  <VerifiedUserRounded fontSize="large" style={{ color: green[400] }}/> : <InfoRounded fontSize="large" style={{ color: green[400] }}/>}
                                        >
                                            <Box style={{ display: "flex", justifyContent:"space-between", alignItems: "center"}}>
                                                <Box>
                                                    {userInfo.paymentDelay < 0 &&
                                                        <Typography variant="body1" color="error">{userInfo.paymentDelay * -1} j de retard</Typography>
                                                    }
                                                </Box>
                                                <Typography variant="h6">
                                                    {Math.round(userInfo.totalPayed/userInfo.totalToPay * 100)} % payé
                                                </Typography>
                                            </Box>
                                        </MiniPaper>
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <MiniPaper
                                            title="Dernier paiement"
                                            subtitle={!isEmpty(lastPayment) && new Date(lastPayment.timePayment).toLocaleDateString('fr-FR')}
                                            avatar={<MonetizationOnRounded fontSize="large" style={{ color: amber[400] }}/>}
                                        >
                                            <Typography variant="h6">
                                                <Currency value={!isEmpty(lastPayment) && lastPayment.money} />
                                            </Typography>
                                        </MiniPaper>
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <MiniPaper
                                            title="Abonnement"
                                            subtitle={this.props.abo.name}
                                            avatar={<AssignmentTurnedInRounded fontSize="large" style={{ color: blue[400] }}/>}
                                        >
                                            <Typography variant="h6">
                                                <Currency value={this.props.abo.total} />
                                            </Typography>
                                        </MiniPaper>
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <MiniPaper
                                            title="Récurrence"
                                            subtitle={this.props.abo.type === 'Cash' ? "Paiement Unique" : `Tous les ${userInfo.periodicity} jours`}
                                            avatar={<CalendarViewDayRounded fontSize="large" style={{ color: pink[400] }}/>}
                                        >
                                            <Typography variant="h6">
                                                <Currency value={this.props.abo.type === 'Cash' ? this.props.abo.total : this.props.abo.mensualite} />
                                            </Typography>
                                        </MiniPaper>
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <RegistrationDatePaper userInfo={userInfo} />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={5}>
                                {this.props.abo.type === 'Day' &&
                                    <DoughnutChart 
                                        userInfo={userInfo} 
                                        paymentList={this.state.paymentList} 
                                        title="Etat Paygo"
                                        displayTitle={false}
                                        abo={this.props.abo}
                                        // legendPosition="left"
                                    />
                                }
                            </Grid>
                            <Grid item xs={12} md={7}>
                                {this.props.abo.type === 'Day' &&
                                    <ProgressChart 
                                        userInfo={userInfo} 
                                        paymentList={this.state.paymentList} 
                                        paymentsIDList={paymentsIDList} 
                                        reportsIDList={reportsIDList} 
                                        REPORTS={REPORTS} 
                                        abo={this.props.abo}
                                    />
                                }
                            </Grid>
                           
                            
                            <Grid item xs={12}>
                                {this.props.abo.type === 'Day' &&
                                    <BarChart 
                                        abo={this.props.abo}
                                        userInfo={userInfo} 
                                        paymentList={this.state.paymentList} 
                                        title="Paiements" 
                                        legendPosition="bottom" 
                                    />
                                }
                            </Grid>
                            <Grid item xs={12}>
                                {this.props.abo.type === 'Day' &&
                                    <LineChart 
                                        abo={this.props.abo}
                                        userInfo={userInfo} 
                                        paymentList={this.state.paymentList} 
                                        title="Cumul des paiements" 
                                        legendPosition="bottom" 
                                    />
                                }
                            </Grid>
                        </Grid>
                    </Box>
                }
                { !loading && isEmpty(this.state.paymentList) &&
                    <Box>
                        <Alert severity="info">Pas Assez d'info</Alert>
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={3}>
                                <RegistrationDatePaper userInfo={userInfo} />
                            </Grid>
                        </Grid>
                    </Box>
                }
            </div>
        )
    }
}

export default Stats;
